import React, { useState } from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const SelectOption = ({
  name,
  label,
  value,
  onChange,
  data,
  style,
  size,
  selectCss,
  labelStyle,
  onFocus,
  onScroll,
  ...props
}) => {
  return (
    <FormControl size={size} sx={style} >
      <InputLabel sx={labelStyle} id={name}>{label}</InputLabel>
      <Select
        labelId={name}
        id={name}
        value={value || ""}
        name={name}
        label={label}
        onChange={onChange}
        sx={selectCss}
        required
        onFocus={onFocus}
        {...props}
        
        // MenuProps={{
        //   PaperProps: {
        //     onScroll: (event) => {
        //       console.log(event);
        //       console.log("we scroll");
        //     }
          
        //   },
        // }}
        // MenuProps={{
          //   disableScrollLock: true,
        // }}

      >
        {data?.map((info, index) => {
          const values = Object.values(info);
          return (
            <MenuItem key={index} value={values[0]}>
              {values[1]}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
const SelectOptionEdit = ({
  name,
  label,
  value,
  onChange,
  data,
  style,
  size,
  selectCss,
  labelStyle,
  onFocus,
  onScroll,
  defaultSelected,
  required,
  ...props
}) => {

  const [focus,setFocus]=useState(false)
  return (
    <FormControl size={size} sx={style} >
      <InputLabel sx={labelStyle} id={name}>{value||focus?label:defaultSelected}</InputLabel>
      <Select
      
        labelId={name}
        id={name}
        value={value || ""}
        name={name}
        label={label}
        onChange={onChange}
        sx={selectCss}
        onFocus={()=>{
          if(onFocus)
          onFocus()
          !value&& setFocus(true)
        }}
        onBlur={()=>!value&&setFocus(false)}
        
        {...props}
        
        // MenuProps={{
        //   PaperProps: {
        //     onScroll: (event) => {
        //       console.log(event);
        //       console.log("we scroll");
        //     }
          
        //   },
        // }}
        // MenuProps={{
          //   disableScrollLock: true,
        // }}

      >
        {data?.map((info, index) => {
          const values = Object.values(info);
          return (
            <MenuItem key={index} value={values[0]}>
              {values[1]}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
export {SelectOptionEdit}
export default SelectOption;
